import { Typography } from "@/components/ui/typography";

export const Statistic = () => {
  return (
    <div className="flex gap-5 items-center justify-around w-full max-sm:flex-col">
      <div className="flex flex-col gap-3 items-center">
        <Typography variant={"title"} className="font-semibold text-primary">
          +70,000
        </Typography>
        <Typography>Дагагч</Typography>
      </div>
      <div className="flex flex-col gap-3 items-center">
        <Typography variant={"title"} className="font-semibold text-primary">
          +50,000,000₮
        </Typography>
        <Typography>Giveway</Typography>
      </div>
      <div className="flex flex-col gap-3 items-center">
        <Typography variant={"title"} className="font-semibold text-primary">
          +75%
        </Typography>
        <Typography>Оновчтой Арилжааны Групп</Typography>
      </div>
    </div>
  );
};
